export function useEmbed() {
  const route = useRoute()

  const isShopifyEmbedMode = computed(
    () => String(route.query.embedMode || '') === 'shopify',
  )

  function parseOrigin(value: unknown) {
    if (typeof value !== 'string') return null
    try {
      const origin = new URL(value).origin
      return /^https?:\/\//.test(origin) ? origin : null
    } catch {
      return null
    }
  }

  function allowsWildcardParentOrigin() {
    const embedMode = String(route.query.embedMode || '')
    return !isShopifyEmbedMode.value
      && (embedMode === 'local' || embedMode === 'dev' || import.meta.dev)
  }

  const targetOrigin = computed(() => {
    const origin = parseOrigin(route.query.hostOrigin)
    if (origin) return origin
    return allowsWildcardParentOrigin() ? '*' : null
  })

  const isEmbedded = computed(() => {
    if (!import.meta.client) return false
    return window.parent !== window
  })

  function post(type: string, data?: unknown) {
    if (!import.meta.client || window.parent === window) return
    if (!targetOrigin.value) return
    try {
      window.parent.postMessage({ type, data }, targetOrigin.value)
    } catch {
      // no-op
    }
  }

  return { isEmbedded, post, targetOrigin }
}
